var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brackets__mobile-item"},[(_vm.data.is_tft)?[_c('TftUiBracketItem',{attrs:{"data":_vm.data}})]:_vm._l((_vm.data),function(item){return _c('div',[_c('BracketItem',{attrs:{"data":item}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }